module.exports = __webpack_public_path__ + "static/media/jayco3.6a81632c.JPG";